export function formatApiError(err) {
  const d = err?.message || err?.details || err?.hint || err;
  if (d == null) return "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (typeof d === "object" && d.msg) return d.msg;
  return String(d);
}
